import React from 'react'
import { Link } from 'react-router-dom'
import { LinkGuardProps } from './LinkGuard.model'

export const LinkGuard = ({ condition, url, children }: LinkGuardProps) => {
  return condition ? <Link to={url}>{children}</Link> : children
}
